import type { Theme } from '@mui/material';

import type { ThemeName, ThemeValue } from '../types';

export function getTheme(
  themeName: ThemeName | null,
): () => Promise<ThemeValue> {
  switch (themeName) {
    case 'Dark':
      return async () => ({
        name: 'Dark',
        theme: (await import('../../themes/darkTheme').then(
          mod => mod.default,
        )) as unknown as Theme,
      });
    default:
      return async () => ({
        name: 'Light',
        theme: (await import('../../themes/lightTheme').then(
          mod => mod.default,
        )) as unknown as Theme,
      });
  }
}
